module.exports = __webpack_public_path__ + "img/apple_download_icon.ed2d3210.png";